import { useGame } from '../context/GameContext';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import PageWrapper from '../components/wrapper/FlexiblePageWrapper';
import GhostWrapper from '../components/wrapper/GhostWrapper';
import GameGhosts from './../components/ghosts/GameGhosts';
import GameWrapper from '../components/wrapper/GameWrapper';
import Header from './../components/general/Header';
import Title from './../components/text/Title';
import Subtitle from './../components/text/Subtitle';
import ButtonWrapper from '../components/wrapper/ButtonWrapper';
import Button from './../components/general/Button';
import TextLink from '../components/text/TextLink';
import GamePlaceholder from './GamePlaceholder';
import GameCardIntermission from '../components/game/GameCardIntermission';
import Footer from './../components/general/Footer';

function Game() {
  const { t } = useLanguage();

  const navigate = useNavigate();
  const { gameState, nextRound, getCurrentRound } = useGame();

  const handleNextRound = () => {
    nextRound();
    navigate(`/game`);
  };

  // prettier-ignore
  const handleExitGame = () => {
    navigate(`/game/end?r1=${encodeURIComponent(gameState?.rounds[0].roundScore ?? 0)}&r2=${encodeURIComponent(gameState?.rounds[1].roundScore ?? 0)}&r3=${encodeURIComponent(gameState?.rounds[2].roundScore ?? 0)}&ts=${encodeURIComponent(gameState?.totalScore ?? 0)}`);
  };

  // prettier-ignore
  const handleGiveUp = () => {
    navigate(`/game/end?r1=${encodeURIComponent(gameState?.rounds[0].roundScore ?? 0)}&r2=${encodeURIComponent(gameState?.rounds[1].roundScore ?? 0)}&r3=${encodeURIComponent(gameState?.rounds[2].roundScore ?? 0)}&ts=${encodeURIComponent(gameState?.totalScore ?? 0)}`);
  };

  /* Game page while loading */
  if (gameState.isLoading) {
    return <GamePlaceholder status="loading" />;
  }

  /* Game page if error exists */
  if (gameState.error) {
    return <GamePlaceholder status="error" errorName={gameState.error} />;
  }

  /* Game page if unable to obtain currentRound*/
  const currentRound = getCurrentRound();

  if (!currentRound) {
    return <GamePlaceholder status="noCurrentRound" />;
  }

  return (
    <PageWrapper>
      <GhostWrapper>
        <Header text={t('headerTitle')} />
        <GameWrapper>
          <Title size="small" text={t('title')} />
          {/* Round number */}
          <Subtitle
            position="center"
            text={`${t('intermissionRound')} ${gameState.currentRoundIndex + 1}/3`}
          />

          <section className="px-8 max-w-md sm:max-w-lg md:max-w-xl lg:max-w-3xl xl:max-w-4xl text-sm flex flex-col gap-2">
            <span className="text-subtitle-light dark:text-subtitle-dark font-medium">
              {' '}
              {t('intermissionInformation')}{' '}
            </span>
            <span className="text-subtitle-light dark:text-subtitle-dark italic">
              "{t('biasInformation')}"
            </span>
            <GameCardIntermission text={currentRound.prompt.search} suggestions={currentRound.suggestions} />
          </section>

          <ButtonWrapper>
            <TextLink text={t('giveUp')} onClick={handleGiveUp} />
            {/* Next round button */}
            {gameState.gameEnded ? (
              <Button onClick={handleExitGame} text={t('seeGameResults')} />
            ) : (
              <Button onClick={handleNextRound} text={t('goToNextRound')} />
            )}
          </ButtonWrapper>
        </GameWrapper>
      </GhostWrapper>
      <GameGhosts />
      <Footer />
    </PageWrapper>
  );
}

export default Game;
